import { getContactPage, getGlobals } from "storyblok/api"
import Meta from "components/Meta"
import ContactPage from "components/DynamicComponent/organisms/ContactPage"

export default function Contact({ meta, story }) {
  return (
    <>
      <Meta info={meta} />
      <ContactPage story={story} />
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()
  const story = await getContactPage(preview)

  return {
    props: {
      story: story ?? null,
      meta: story?.page?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
